import React, {FC, RefObject, useRef} from 'react';
import styled from 'styled-components';

import {RendererOf} from '../../../helpers/src/react/reactHelpers';
import {fontSizes} from '../styles/fontStyles';

interface FlexWrapperProps {
  margin?: number;
  direction?: string;
}

export const FlexWrapper = styled.div<FlexWrapperProps>`
  & > * {
    margin: ${(p) => p.margin && `${p.margin}px`};
    flex-shrink: 0;
  }

  display: flex;
  flex-direction: ${(p) => p.direction || 'row'};
  flex-wrap: wrap;
`;

export const StorybookRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 8px;
`;

export const StorybookHeader = styled.div`
  padding-bottom: 6px;
  font-size: ${fontSizes.veryLarge};
  border-bottom: 2px solid ${(p) => p.theme.greys.shade40};
  width: 100%;
  margin-bottom: 12px;
`;

export const StorybookItem = styled.div`
  display: inline-flex;
  margin: 0 8px 8px 0;
`;

export const StorybookCard = styled.div`
  padding: 16px;
  background: ${(p) => p.theme.greys.white};
  border: 1px solid ${(p) => p.theme.greys.shade40};
  border-radius: 12px;
  width: 300px;
`;

interface DropdownRefWrapperProps {
  children: RendererOf<RefObject<HTMLDivElement>>;
}

/** Renders its children by passing them an anchor. Useful when rendering a component that depends on Reposition */
export const RepositionAnchorProvider: FC<DropdownRefWrapperProps> = (props) => {
  const divRef = useRef<HTMLDivElement>(null);

  return <div ref={divRef}>{props.children(divRef)}</div>;
};
